import { useEffect, useState } from "react";
import useUser from "../../hooks/user/useUser";
import useCountry from "../../hooks/config/useConfig";
import PaymentContext from "../../context/Payment/PaymentContext";
import { useContext } from "react";

export const PaymentGate = () => {
  const { isLoggedIn, userState } = useUser();
  const { countryFeatures } = useCountry();
  const { isPaid, icId, refreshPaymentStatus, countryId } = useContext(PaymentContext);
  const [isHover, setIsHover] = useState(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const onChange = (e: MediaQueryListEvent | MediaQueryList) => setIsMobile((e as MediaQueryList).matches ?? (e as MediaQueryListEvent).matches);
    onChange(mq);
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange as any);
    else (mq as any).addListener(onChange);
    return () => {
      if (typeof mq.removeEventListener === 'function') mq.removeEventListener('change', onChange as any);
      else (mq as any).removeListener(onChange);
    };
  }, []);

  useEffect(() => {
    if (isLoggedIn) refreshPaymentStatus();
  }, [isLoggedIn, refreshPaymentStatus]);

  // Show overlay only when user has NOT paid and is from country_id in {1 (UY), 5 (CO), 7 (CL)}
  // If paid is null or country not in list → no popup
  const shouldBlock = isLoggedIn && (isPaid === false) && (countryId === 1 || countryId === 5 || countryId === 7);

  // Prevent background scroll while popup is visible
  useEffect(() => {
    if (shouldBlock) {
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prevOverflow;
      };
    }
  }, [shouldBlock]);

  if (!shouldBlock) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.6)',
      zIndex: 99999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ position: 'relative', display: 'inline-block', maxWidth: '90%', maxHeight: '80%' }}>
        <img
          alt="Acceso restringido"
          style={{ width: '100%', height: 'auto', objectFit: 'contain', display: 'block' }}
          src={(() => {
            const isRegistered = icId !== null;
            // Country-specific artwork
            if (countryId === 7) {
              // Chile: always sin legal (all users treated as no registrados)
              return isMobile
                ? 'https://cdn1.infocasas.com.uy/web/69133116cc990_popup-cl_mobile_sin_legal.png'
                : 'https://cdn1.infocasas.com.uy/web/6913311671cc9_popup-cl_desktop_sin-legal.png';
            }
            if (countryId === 5) {
              // Colombia: always sin legal artwork
              return isMobile
                ? 'https://cdn1.infocasas.com.uy/web/6908bf73047b0_popup-co_mobile_sin_legal.png'
                : 'https://cdn1.infocasas.com.uy/web/6908bf723891d_popup-co_desktop_sin_legal.png';
            }
            // Default (UY): always no_registrados artwork
            return isMobile
              ? 'https://cdn1.infocasas.com.uy/web/68da88b56743d_popup_mobile_no_registrados.png'
              : 'https://cdn1.infocasas.com.uy/web/68da88b559130_popup_desktop_no_registrados.png';
          })()}
        />
        <button
          type="button"
          onClick={() => {
            const defaultMsg = `Hola, quiero activar Iris. Mis datos: nombre=${userState?.name || ''}, email=${userState?.email || ''}, teléfono=${userState?.phone || ''}.`;
            const waLink =
              countryId === 7
                ? 'https://wa.me/56983106930'
                : countryId === 5
                  ? 'https://wa.me/573173637660'
                  : (countryFeatures?.contact_wame || '');
            if (!waLink) return;
            const url = waLink.includes('text=')
              ? `${waLink}%20${encodeURIComponent(defaultMsg)}`
              : `${waLink}?text=${encodeURIComponent(defaultMsg)}`;
            window.open(url, '_blank');
          }}
          style={{
            position: 'absolute',
            bottom: isMobile ? 'calc(4% + 12px)' : 'calc(6% + 12px)',
            left: isMobile ? '50%' : '60%',
            border: 'none',
            background: 'transparent',
            padding: 0,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: isMobile ? '58%' : 220,
            height: isMobile ? undefined : 60,
            aspectRatio: '220 / 60',
            transform: isMobile
              ? (isHover ? 'translateX(-50%) scale(1.04)' : 'translateX(-50%) scale(1.0)')
              : (isHover ? 'scale(1.04)' : 'scale(1.0)'),
            filter: isHover ? 'drop-shadow(0 6px 16px rgba(0,0,0,0.25))' : 'none',
            transition: 'transform 120ms ease, filter 120ms ease'
          }}
          aria-label="Contactarme"
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <img
            alt="Contactarme"
            src={(() => {
              if (countryId === 7) {
                return isHover
                  ? 'https://cdn1.infocasas.com.uy/web/6913311467363_btn_contactarme_up.svg'
                  : 'https://cdn1.infocasas.com.uy/web/691331142dec3_btn_contactarme_down.svg';
              }
              if (countryId === 5) {
                return 'https://cdn1.infocasas.com.uy/web/6908bf5d42275_btn_contactarme_down.svg';
              }
              return 'https://cdn1.infocasas.com.uy/web/68da903f27937_btn_contactarme_down-(1).svg';
            })()}
            style={{
              width: '100%',
              height: isMobile ? '50%' : '100%',
              objectFit: 'contain',
              display: 'block',
              transform: isMobile ? 'translateX(0px)' : 'translateX(15px)'
            }}
          />
        </button>
      </div>
    </div>
  );
}

export default PaymentGate;


